"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var shouldSkipDragEvent = exports.shouldSkipDragEvent = function shouldSkipDragEvent(dragEvent) {
  return !dragEvent || !dragEvent.destination;
};